export const AvailableEnumsConst = ['ApplicationType', 'SedimentType', 'MaximumHydraulicFlowUnit'] as const;

export type AvailableEnums = typeof AvailableEnumsConst[number];
export type ApplicationType = typeof applicationTypes[number];
export type SedimentType = typeof sedimentTypes[number];
export type MaximumHydraulicFlowUnit = typeof maximumHydraulicFlowUnits[number];

export const applicationTypes = <const>[
  'Logistic Area',
  'Streets & Parking',
  'Highways',
  'Pedestrian Zone & Non-metal Roof',
  'Metal Roof',
  'Industrial',
  'All-purpose',
];
export const sedimentTypes = <const>['Coarse (US)', 'Average (DE, AT, CH)', 'Average (US, UK)', 'Fine', 'Ultra Fine (US)'];
export const maximumHydraulicFlowUnits = <const>['L/s', 'L/s*ha', 'mm/h'];

export const Enums: Record<AvailableEnums, readonly string[]> = {
  ApplicationType: applicationTypes,
  SedimentType: sedimentTypes,
  MaximumHydraulicFlowUnit: maximumHydraulicFlowUnits,
};

// eslint-disable-next-line no-magic-numbers
export const ALLOWED_TEMPERATURES = [5, 10, 15, 20, 25, 30] as const;
export type Temperature = typeof ALLOWED_TEMPERATURES[number];
export const waterTemperature: Temperature = 25;

export const isApplication = (application: string | AvailableEnums): application is ApplicationType => applicationTypes.some((at) => at === application);
export const isSedimentType = (sedimentType: string | SedimentType): sedimentType is SedimentType => sedimentTypes.some((st) => st === sedimentType);
export const isMaximumHydraulicFlowUnit = (unit: string | MaximumHydraulicFlowUnit): unit is MaximumHydraulicFlowUnit =>
  maximumHydraulicFlowUnits.some((u) => u === unit);
